/**
 * O que o card e o aviso do sistema dizem (#536).
 *
 * Os dois dizem a MESMA coisa — nome em cima, mensagem embaixo —, e por isso
 * o texto mora num lugar só. Se cada um montasse o seu, o dia em que "Cliente"
 * virasse "Contato" num deles seria o dia em que a pessoa passa a ver dois
 * nomes para o mesmo aviso.
 *
 * Texto de interface não mora no contrato: a API manda o trecho vazio quando a
 * mensagem é só anexo, e o tipo dele. Dizer "Enviou uma foto" é daqui.
 */

import type { AvisoDeAutomacao, Notificacao } from '@cliqcrm/contracts';

/** Identidade ainda não resolvida: o lead escreveu, mas ninguém sabe quem é. */
const SEM_NOME = 'Cliente';

export function nomeDaNotificacao(notificacao: Notificacao): string {
  // A menção (#569) diz quem chamou: é a pergunta de quem recebe o aviso.
  if (notificacao.tipo === 'mencao') {
    return `${notificacao.autor?.trim() || 'Alguém da equipe'} mencionou você`;
  }
  const nome = notificacao.cliente.nome_exibicao?.trim();
  return nome ? nome : SEM_NOME;
}

const SO_ANEXO: Readonly<Record<string, string>> = {
  image: 'Enviou uma foto',
  audio: 'Enviou um áudio',
  video: 'Enviou um vídeo',
};

export function mensagemDaNotificacao(notificacao: Notificacao): string {
  const { trecho, tipo } = notificacao.mensagem;
  if (trecho.trim() !== '') return trecho;
  return (tipo && SO_ANEXO[tipo]) ?? 'Enviou um arquivo';
}

/**
 * O que o card do aviso de automação diz (#903).
 *
 * A API manda a chave do motor (`no_first_reply`); a frase é daqui. A chave
 * que esta lista não conhece ainda diz algo útil, em vez de mostrar a chave
 * crua — que é vocabulário do motor, não da pessoa.
 */
const TEXTO_DO_AVISO: Readonly<Record<string, string>> = {
  no_first_reply: 'Uma conversa está sem a primeira resposta.',
};

export function textoDoAviso(aviso: AvisoDeAutomacao): string {
  return TEXTO_DO_AVISO[aviso.aviso] ?? 'Uma automação pediu a sua atenção.';
}
